
import { Directive,HostListener,Input } from '@angular/core';

import { environment } from '../../environments/environment';


// var sessiontime = []; 
@Directive({
  selector: '[eventTracker]' 
})

export class GaDirective  {
  eventdata:any;
  profileInfo:any;
  userProfileData:any;
  user_id:number;
  lat_long:any;
  current_time_zone:any;
  

constructor() { } 
  @Input('eventTracker') option:any;
  @HostListener('click', ['$event']) onClick($event){  
    // console.log(this.option.category+'===='+this.option.action+"========="+this.option.product_type+"============"+this.option.product_id);

    let product_id=(isNaN(this.option.product_id)==false)? parseInt(this.option.product_id):0;

    let product_type='product_type_'+this.option.product_type+'_'+product_id;

    (<any>window).ga('send', 'event', {
      eventCategory: this.option.category,
      eventAction: this.option.action,
      eventLabel: product_type
    });

    let temp='';
    if(this.option.product_id!='' && this.option.product_id!=undefined)
    {
      temp=this.generateRandStr(5)+this.option.product_id+this.generateRandStr(5);
    
    }
    
    
    (<any>window).fbq('track', 'ViewContent', {
      content_name: temp,
      content_category:this.option.category
     },
    );

    
    // fbq('track', 'PageView');

    
  }


  generateRandStr(length)
  {
    var randomString;
      var text = "";
      var possible = "123456789";
      for(var i = 0; i < length; i++) {
          text += possible.charAt(Math.floor(Math.random() * possible.length));
      }
      return text;
  }
  
  getProductType(id)
  {
    if(id==1)
      return 'feed';
    else if(id==3)
      return 'journal';
    else if(id==8)
      return 'cme';
      
  }
  
}
